import { Icon } from '@iq/react-components';
import React from 'react';

import { severityWeight } from './EventTimelineState';
import Indicator from './Indicator';
import Pill from '../../Pill';
import { formatSiteDatetime } from '../../../datetimeUtils';
import { SEVERITIES, STATELESS_EVENTS } from '../../../constants';

export const IotBucketTooltip = ({ bucket, timezone }) => (
  <div className="event-timeline-tooltip">
    <p>
      <label className="event-timeline-tooltip__fixed-width-label">From:</label>
      {formatSiteDatetime(Number(bucket.from), timezone, true)}
    </p>
    <p>
      <label className="event-timeline-tooltip__fixed-width-label">To:</label>
      {formatSiteDatetime(Number(bucket.to), timezone, true)}
    </p>
    <div className="event-timeline-tooltip__severity-groups">
      {[...bucket.numEventsPerType]
        .sort((a, b) => (severityWeight(a.severity) > severityWeight(b.severity) ? -1 : 1))
        .map((type) => (
          <p key={type.severity}>
            <Indicator severity={type.severity} />
            {type.count} {SEVERITIES[type.severity]} event{type.count > 1 ? 's' : ''}
          </p>
        ))}
    </div>
  </div>
);

export const IotEventTooltip = ({ event, timezone }) => (
  <div className="event-timeline-tooltip">
    <p
      className={`event-timeline-tooltip__severity event-timeline-tooltip__severity--${event.severity}`}
    >
      {SEVERITIES[event.severity]}
    </p>
    <p className="event-timeline-tooltip__timestamp">
      {formatSiteDatetime(Number(event.timestamp), timezone, true)}
    </p>
    <p>{event.message}</p>
  </div>
);
function toTitleCase(str) {
  // eslint-disable-next-line func-names
  return str.toLowerCase().replace(/(?:^|[\s-/])\w/g, (match) => match.toUpperCase());
}

export const UserEventTooltip = ({ event, timezone, comments }) => {
  const isStateLessEvent = STATELESS_EVENTS.includes(event.type);

  const tooltipDetails = [
    {
      label: 'Planned',
      value: event.from && formatSiteDatetime(event.from, timezone),
    },
    {
      label: 'Executed',
      value: event.executionFrom && formatSiteDatetime(event.executionFrom, timezone),
    },
    {
      label: 'Assignee',
      value: event.assignedTo && event.assigneeName,
    },
    {
      label: 'Status',
      value: !isStateLessEvent && event.state && toTitleCase(event.state),
    },
  ];
  return (
    <div className="event-timeline-tooltip">
      <div className="event-timeline-tooltip__severity">
        <Indicator
          eventState={isStateLessEvent ? 'stateless' : event.state}
          round
        />
        {event.name}
      </div>
      <div className="event-timeline-tooltip__details">
        {tooltipDetails.map(
          (t, i) =>
            t.value && (
              <div key={`tooltip-detail-${t.label}-${i}`}>
                <span>{t.label}</span>
                <span>{t.value}</span>
              </div>
            )
        )}
      </div>

      <div className="event-timeline-tooltip__indicators">
        {comments.length > 0 && (
          <div className="event-timeline-tooltip__indicators--comments">
            <Icon icon="he-chat" />
            <Pill text={comments.length} />
          </div>
        )}
        {event.files?.length > 0 && (
          <div className="event-timeline-tooltip__indicators--attachments">
            <Icon icon="he-attachment" />
            <Pill text={event.files.length} />
          </div>
        )}
      </div>
    </div>
  );
};
